<template>
<div class="formholder">
    <div class="formholder1" :style="{height:property.height+'px'}"></div>
    <div class="formholderline" v-if="property.radio==1"></div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {
      }
    };
  }
};
</script>
